export default __webpack_public_path__ + "static/media/c9.6be10611.png";